"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionOrGroupType = exports.OptionGroupType = exports.OptionType = exports.ValueType = exports.SingleValueType = void 0;

var _iconName = require("../utils/propTypes/iconName");

var _react = require("react");

var SingleValueType = _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.bool]);

exports.SingleValueType = SingleValueType;

var ValueType = _react.PropTypes.oneOfType([SingleValueType, _react.PropTypes.arrayOf(SingleValueType)]);

exports.ValueType = ValueType;

var OptionType = _react.PropTypes.shape({
  avatar: _react.PropTypes.node,
  badge: _react.PropTypes.object,
  buttonText: _react.PropTypes.node,
  disabled: _react.PropTypes.bool,
  dropdownClassName: _react.PropTypes.string,
  dropdownText: _react.PropTypes.node,
  icon: (0, _iconName.getIconNamePropType)(),
  help: _react.PropTypes.node,
  imageUrl: _react.PropTypes.string,
  loading: _react.PropTypes.bool,
  tag: _react.PropTypes.object,
  tagUse: _react.PropTypes.string,
  text: _react.PropTypes.string,
  title: _react.PropTypes.string,
  value: SingleValueType
});

exports.OptionType = OptionType;

var OptionGroupType = _react.PropTypes.shape({
  dropdownClassName: _react.PropTypes.string,
  dropdownText: _react.PropTypes.node,
  emptyMessage: _react.PropTypes.string,
  options: _react.PropTypes.arrayOf(OptionType.isRequired).isRequired,
  text: _react.PropTypes.string,
  title: _react.PropTypes.string
});

exports.OptionGroupType = OptionGroupType;

var OptionOrGroupType = _react.PropTypes.oneOfType([OptionGroupType, OptionType]);

exports.OptionOrGroupType = OptionOrGroupType;